import { useSearchParams } from "react-router-dom";
import IndustryBrandDemo from "./shared/IndustryBrandDemo";
import CategoryPortfolioGallery from "./shared/CategoryPortfolioGallery";
import { isGalleryVariant } from "@/data/portfolioGalleryRegistry";
import {
  BRAND_WEB_VARIANTS,
  DEFAULT_BRAND_WEB_VARIANT,
  getBrandWebVariant,
  isValidBrandWebVariant,
} from "./brandWebVariants";
import "./BrandWebDemo.css";

function VariantPicker({ active, embed, onSelect }) {
  if (embed) return null;

  return (
    <div className="bw-variant-bar" data-testid="brand-web-variant-picker">
      <div className="bw-variant-bar__inner">
        <span className="bw-variant-bar__label">업종별 사례</span>
        <div className="bw-variant-bar__tabs" role="tablist">
          {BRAND_WEB_VARIANTS.map((v) => (
            <button
              key={v.id}
              type="button"
              role="tab"
              aria-selected={active === v.id}
              className={`bw-variant-bar__tab${active === v.id ? " is-active" : ""}`}
              style={{ "--v-accent": v.accent }}
              onClick={() => onSelect?.(v.id)}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

/** Portfolio #1 — 홈페이지 제작 (업종별 제작 사례) */
export default function BrandWebDemo({
  embed = false,
  variant: variantProp,
  demo: demoProp,
  onDemoChange,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawVariant = variantProp || searchParams.get("variant") || DEFAULT_BRAND_WEB_VARIANT;
  const variant = isValidBrandWebVariant(rawVariant) ? rawVariant : DEFAULT_BRAND_WEB_VARIANT;
  const meta = getBrandWebVariant(variant);

  const selectVariant = (id) => {
    const next = new URLSearchParams();
    next.set("variant", id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className={`bw-demo-root${embed ? " bw-demo-root--embed" : ""}`} data-variant={variant}>
      <VariantPicker active={variant} embed={embed} onSelect={selectVariant} />
      {!embed && (
        <div className="bw-variant-meta">
          <strong>{meta.title}</strong>
          <span>{meta.description}</span>
        </div>
      )}
      {isGalleryVariant(variant) ? (
        <CategoryPortfolioGallery categoryId={variant} embed={embed} />
      ) : (
        <IndustryBrandDemo
          industry={variant}
          embed={embed}
          demo={demoProp}
          onDemoChange={onDemoChange}
        />
      )}
    </div>
  );
}
